<template>
	<div class="drop-menubar" @mousedown="stopEvent" @click="stopEvent">
		<div class="menubar-content">
			<history-box></history-box>
		</div>
	</div>
</template>

<script setup lang="ts">
import HistoryBox from "@/ui/mouse/HistoryBox.vue";
/**
 * Stop event bubbling to prevent root element loosing focus
 */
function stopEvent(e:MouseEvent) {
	e.stopPropagation();
}
</script>

<style>

</style>